import React from 'react';
import Banner from '../Components/banner';
import Homepage from './homepage';


const LayoutPage = () => {
    return (
        <>
            {/* <Header /> */}
            <main className="main-content">

                <Banner/>
                <Homepage/>
               

              
            </main>
            
        </>
    );
}

export default LayoutPage;
